if (customElements && !customElements.get('brand-timeline')) {
  class BrandTimeline extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (this.timelineScroll) return;
      this.init();
    }

    disconnectedCallback() {
      // Theme editor re-renders / removes sections: clean up so stale pins don't linger
      queueMicrotask(() => { if (!this.isConnected) this.destroy(); });
    }

    destroy() {
      [this.timelineScroll, this.sphereTl].forEach((tl) => {
        if (!tl) return;
        if (tl.scrollTrigger) tl.scrollTrigger.kill(true);
        tl.kill();
      });
      this.timelineScroll = undefined;
      this.sphereTl = undefined;
    }

    initHorizontalScroll() {
      const container = this.querySelector('[data-role="layers-container"]');
      if (!container) {
        console.error('Not found: layers-container');
        return;
      }

      const layersListContainer = container.querySelector('[data-role="layers-list"]');
      const layersArr = [...layersListContainer.children];
      this.durationScroll = layersArr.length - 1;

      gsap.set(layersListContainer, {
        display: 'flex',
        alignItems: 'stretch',
        justifyContent: 'start'
      });

      this.timelineScroll = gsap.timeline({
        scrollTrigger: {
          id: 'layers',
          trigger: container,
          pin: true,
          scrub: 0.5,
          start: 'top top',
          end: () => {
            const allLayersWidth = layersArr
              .slice(1)
              .reduce((acc, elem) => acc += elem.clientWidth, 0);
            return `+=${allLayersWidth}`;
          },
          invalidateOnRefresh: true,
          refreshPriority: 1
        }
      });

      this.timelineScroll.to(
        layersListContainer,
        {
          xPercent: (-100 * (layersArr.length - 1)),
          ease: 'none',
          duration: this.durationScroll,
          onUpdate: function() {
            // console.log(this.time().toFixed(3));
          }
        }
      );
    }

    initAnimateLineIcon() {
      if (typeof DrawSVGPlugin === 'undefined') {
        console.error('Not found GSAP Plugin. DrawSVGPlugin');
        return;
      }
      if (typeof this.timelineScroll == 'undefined') {
        console.error('Not found: this.timelineScroll');
        return;
      }

      const iconLineContainer = this.querySelector('[data-role="icon-line"]');
      if (!iconLineContainer) return;

      this.timelineScroll.set(iconLineContainer, {
        opacity: 1,
      }, 0.01)

      const iconLinePath = iconLineContainer.querySelector('line');
      if (!iconLineContainer) return;

      this.timelineScroll.set(iconLinePath, {
        drawSVG: '0',
      }, 0)

      this.timelineScroll.fromTo(iconLinePath,
        {
          drawSVG: '35%'
        },
        {
          drawSVG: '55%',
          ease: 'none',
          immediateRender: false,
          duration: 1 - 0.4
        },
        0.4
      );

      this.timelineScroll.to(iconLinePath,
        {
          drawSVG: '65%',
          ease: 'none',
          duration: this.durationScroll - 1
        },
        '>'
      );
    }

    initAnimateSphereIcon() {
      const iconSphere = this.querySelector('[data-role="icon-sphere"] svg');
      if (!iconSphere) return;

      const iconPaths = [...iconSphere.querySelectorAll('path')];
      if (!iconPaths.length) return;

      const odds = iconPaths.filter((_, i) => i % 2 === 0);
      const evens = iconPaths.filter((_, i) => i % 2 === 1);
      const orderedIconPath = [...odds, ...evens];

      gsap.set(iconPaths, {
        opacity: 0,
        scale: 0.85,
        transformOrigin: '50% 50%'
      });

      const tl = this.sphereTl = gsap.timeline({
        id: 'sphere',
        scrollTrigger: {
          trigger: this,
          start: 'top 65%',
          onEnter: () => tl.timeScale(1).play(),
          onLeaveBack: () => tl.timeScale(2).reverse()
        }
      });

      tl.to(orderedIconPath,
        {
          opacity: 1,
          scale: 1,
          duration: 0.5,
          ease: 'power2.out',
          stagger: 0.2
        }
      );
    }

    initAnimate() {
      if (typeof gsap === 'undefined') {
        console.error('Not found: GSAP');
        return;
      }

      this.initHorizontalScroll();
      this.initAnimateLineIcon();
      this.initAnimateSphereIcon();
    }

    init() {
      this.initAnimate();
    }
  }

  customElements.define('brand-timeline', BrandTimeline);
}

/* CKC: keep GSAP ScrollTrigger pins aligned when the page height changes
   (theme editor show/hide/reorder of sections, late-loading images, etc.).
   Without this, a pinned section can stick in the wrong place and overlap the next one. */
(function () {
  if (window.__ckcScrollTriggerRefresh) return;
  window.__ckcScrollTriggerRefresh = true;

  var timer = null;
  var lastHeight = 0;
  var pending = false;
  function bodyHeight() { return document.body ? document.body.scrollHeight : 0; }
  function scheduleRefresh(delay) {
    clearTimeout(timer);
    timer = setTimeout(function () {
      // Don't recalculate pins while a popup covers the page (it froze the popup on phones).
      if (window.__ckcBgPaused) { pending = true; return; }
      pending = false;
      if (window.ScrollTrigger && typeof window.ScrollTrigger.refresh === 'function') {
        window.ScrollTrigger.refresh();
      }
      lastHeight = bodyHeight();
    }, delay || 200);
  }

  document.addEventListener('ckc:bg-pause', function (e) {
    if (!e.detail && pending) scheduleRefresh(300);
  });

  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(function (evt) {
    document.addEventListener(evt, function () { scheduleRefresh(250); });
  });

  function startObserver() {
    if (!('ResizeObserver' in window) || !document.body) return;
    lastHeight = bodyHeight();
    new ResizeObserver(function () {
      var h = bodyHeight();
      if (Math.abs(h - lastHeight) > 2) {
        lastHeight = h;
        scheduleRefresh(300);
      }
    }).observe(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();
